export default "//cloud.imgsmail.ru/cloud.mail.ru/187531/img/build/empty-state/feed_all.png";